import ticketzeeBg from "../assets/ticketzee-bg.webp";
import ticketzeeLogo from "../assets/ticketzee-logo.svg";
import mawalogGroup from "../assets/mawalog-grouped.png";
import mawalogLogo from "../assets/mawalog-logo.svg";
import { Helmet } from "react-helmet-async";
import { useEffect, useRef } from "react";

const OurBrandsSection = () => {
  const ticketzeeRef = useRef(null);
  const mawalogRef = useRef(null);
  useEffect(() => {
    let y1 = 0;
    let y2 = 0;
    let direction1 = 1;
    let direction2 = 1;

    // Animate Ticketzee
    const interval1 = setInterval(() => {
      y1 += direction1 * 0.5;
      if (y1 <= -5 || y1 >= 5) direction1 *= -1;

      if (ticketzeeRef.current) {
        ticketzeeRef.current.style.transform = `translateY(${y1}px)`;
      }
    }, 50);

    // Start Mawalog animation after 500ms delay
    const timeout = setTimeout(() => {
      const interval2 = setInterval(() => {
        y2 += direction2 * 0.5;
        if (y2 <= -5 || y2 >= 5) direction2 *= -1;

        if (mawalogRef.current) {
          mawalogRef.current.style.transform = `translateY(${y2}px)`;
        }
      }, 50);

      return () => clearInterval(interval2);
    }, 500);

    return () => {
      clearInterval(interval1);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Mawalog & Ticketzee | Seamless Event Booking & Supply Chain Solutions.
        </title>
        <meta
          name="description"
          content="Book your tickets anytime, anywhere with Ticketzee and experience effortless access to events. Mawalog simplifies supply chain management, ensuring seamless engineering and delivery from source to doorstep."
        />
        <meta
          name="keywords"
          content="Ticketing system and Mawalog supply chain management."
        />
      </Helmet>
      <section className="w-full px-4 py-16 bg-white font-poppins flex justify-center">
        <div className="flex flex-col lg:flex-row gap-6 w-full max-w-[1400px]">
          {/* Ticketzee Card */}
          <div
            ref={ticketzeeRef}
            className="w-full lg:w-[666px] h-[597px]  rounded-[24px] overflow-hidden relative transition-transform duration-300 ease-in-out"
            style={{
              backgroundImage: `url(${ticketzeeBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 px-6 pb-10 w-full flex flex-col items-center text-center max-w-[500px]">
              <img
                src={ticketzeeLogo}
                alt="Ticketzee Logo"
                className="w-[200px] h-[45px] mb-6"
              />
              <h3 className="text-white text-[20px] font-semibold mb-2">
                Your Ticket to Any Event, Anytime, Anywhere
              </h3>
              <p className="text-white text-[16px] leading-[26px] opacity-90 mb-6">
                Book your tickets now and be part of the pulsating energy that
                everyone will be talking about.
              </p>

              <a
                href="https://www.ticketzee.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-white text-[#222784] font-semibold px-16 py-3 rounded-full text-[16px] hover:bg-gray-100">
                  BOOK NOW →
                </button>
              </a>
            </div>
          </div>

          {/* Mawalog Card */}
          <div
            ref={mawalogRef}
            className="w-full lg:w-[666px] h-[597px] rounded-[24px] overflow-hidden relative transition-transform duration-300 ease-in-out"
            style={{
              background: "linear-gradient(180deg, #DDFEE1 0%, #EBECF8 100%)",
            }}
          >
            {/* Floating Icon Group */}
            <img
              src={mawalogGroup}
              alt="Mawalog Grouped Icons"
              className="absolute top-3 left-1/2 -translate-x-1/2 w-[500px] h-[270px] pointer-events-none select-none"
            />

            {/* Bottom Content */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 px-6 pb-10 w-full flex flex-col items-center text-center max-w-[500px] z-10">
              <img
                src={mawalogLogo}
                alt="Mawalog Logo"
                className="w-[200px] h-[45px] mb-6"
              />
              <h3 className="text-[#1E1E1E] text-[20px] font-semibold mb-2">
                Engineering Flow From Source to Doorstep
              </h3>
              <p className="text-[#4B5563] text-[16px] leading-[26px] mb-6">
                We believe in simplifying the complexities of supply chain
                management and engineering a seamless flow.
              </p>
              <a
                href="https://mawalog.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-white text-[#222784] font-semibold px-16 py-3 rounded-full text-[16px] hover:bg-gray-100">
                  EXPLORE NOW →
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurBrandsSection;
